module.exports = __webpack_public_path__ + "static/media/questions.0c06ef24.svg";